module.exports = __webpack_public_path__ + "static/media/logo.ecea6c3a.png";